<template>
  <div class="index">
    <div v-if="initok" style=" padding-bottom: 30px;">
      <div class="logo"><img :src="data.topImg" /></div>
      <div :id="'ref'+index1"  class="list_block" v-for="(item1,index1) in data.catalogList">
        <div class="title">{{item1.Name}}</div>
        <div class="list cf">
          <div class="one cf"  @click="showCodeFn(index1,index)" v-for="(item,index) in item1.items">
            <div class="img"><img :style="{marginTop: item.Icon==1?'0.2rem':'0' , transform: item.Icon==2?'scale(0.7,0.7)':''}" :src="`https://resource.yatiku.com/resources/sendInformation/imgs/img${item.Icon}.png`"  /></div>
            <div class="text">{{item.Name}}</div>
          </div>
          <div style="text-align: center;" v-if="item1.items.length==0">暂无资料</div>
        </div>
      </div>
      <div class="btmimg"><a :href="link"><img :src="data.bottomImg" /></a></div>
      <div class="pos cf" ref="pos">
        <div class="posin" ref="posin">
          <div v-if="item" ref="list" v-for="(item,index) in posNames" @click="scrollto($event,posArr[index],index)" :style="{ color: posNow==index?'#37A5F0':''}">{{item}}</div>
        </div>
        <div class="arrow" @click="autoScroll">
          <img src="../assets/imgs/icon-arrow.png"/>
        </div>
      </div>
      <div class="collected"><router-link to="/Collected">已收藏</router-link></div>
      <my-dialog ref="dialogs" @close="show=false" @dealColTrue="dealCol(true)" @dealColFalse="dealCol(false)" :wxcode="wxcode" :variable="data.variable" :looking="looking" v-show="show"></my-dialog>
    </div>
    <div v-else><loading></loading></div>
    <alert :con="info"></alert>


    <!-- 打开文件状态2 -->
    <div class="lxl-dialog-container" v-if="dialogEwmFlag">
      <div class="lxl-dialog-box">
        <div class="lxl-dialog-bd">
          <img :src="wxcode" alt="">
        </div>
        <div class="lxl-dialog-ft" v-html="dialogEwmText"></div>
        <div class="lxl-dialog-close" @click="dialogEwmFlag = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>

    <!-- 打开文件状态3 -->
    <div class="lxl-share-container" v-if="shareFlag">
      <img :src="dialogShare" alt="">
    </div>

  </div>
</template>

<script>
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
var longPressTimer = null , scrollFn = null , initPromise = null;
import {findId , dealCol , showCodeFn} from '@/components/public.js'
import Alert from '@/components/Alert'
import Loading from '@/components/Loading'
import myDialog from '@/components/Dialog'
import '@/styles/public.less'
export default {
  components: {
    Alert,Loading,myDialog
  },
  data () {
    return {
      link: '',
      // 打开文件时不同的状态，0-打开文件直接进去，1-打开文件，收藏，2-打开文件，弹出二维码，3-打开文件，弹出分享朋友圈
      showState: '',
      // 文件状态为2时，所展现的二维码说明
      dialogEwmText: '',
      // 文件状态为3时，所展现的分享朋友圈图片地址
      dialogShare: '',
      dialogEwmFlag: false,
      shareFlag: false,
      posNames: [],
      posLen: 0,
      posArr: [],
      posNow: 0,
      collectShow: false,
      show: false,
      data: {},
      wxcode: '',
      looking: {},
      initok: false,
      info: '',
      posOneLen: .6,
      scrollByClick: false,
    }
  },
  methods: {
    scrollto (event, y,index){
      console.log('执行');
      this.scrollByClick = true;
      this.posNow = index;
      console.log(event.target.offsetLeft);
      this.$nextTick(() => {
        console.log(this.$refs.pos);
        this.$refs.pos.scrollLeft = event.target.offsetLeft - event.target.clientWidth;
      });
      window.scrollTo(0,y)
    },
    autoScroll() {
      console.log(this.posNow);
      this.posNow++;
      if (this.posNow === this.posNames.length) {
        this.info = '没有更多';
        this.posNow = this.posNow -1;
        setTimeout(() => {
          this.info = '';
        }, 1500);
        return false;
      }
       window.scrollTo(0,this.posArr[this.posNow]);
      this.$refs.pos.scrollLeft = this.$refs.list[this.posNow].offsetLeft - this.$refs.list[this.posNow].clientWidth;
    },
    dealCol () {
      dealCol(this,this.looking);
    },
    showCodeFn (type,index) {
      this.looking = this.data.catalogList[type].items[index];
      if (this.showState == 0) {
          this.$router.push({
            path: 'Detail',
            query: {
              id: this.looking.Id,
              CatalogId: this.looking.CatalogId,
              title: this.looking.Name
            } 
          });
      }
      if (this.showState == 1) {
        this.show = true;
        this.$refs.dialogs.ewmText = localStorage.getItem('ewmText');
        this.$refs.dialogs.ewmSize = localStorage.getItem('ewmSize');
      }

      if (this.showState == 2) {
        this.dialogEwmFlag = true;
      }
      if (this.showState == 3) {
        if (localStorage.getItem('toDay') == new Date().getDate()) {
          this.$router.push({
            path: 'Detail',
            query: {
              id: this.looking.Id,
              CatalogId: this.looking.CatalogId,
              title: this.looking.Name
            } 
          });
          return false;0.
          0
        }
        this.shareFlag = true;
        localStorage.setItem('looking', JSON.stringify(this.looking));
      }
    },
    getdata () {
      initPromise = new Promise((resolve, reject)=> {
        this.axios.get(
          'http://app.yatiku.com/app/getActivityAllSendInformation',
          {params: {catalogId, codeId }}
        ).then((res) => {
            console.log(res.data);
            document.title = res.data.catalogType.Name;
            res.data.catalogType.variable.forEach(item => {
              if (item.watermark) {
                localStorage.setItem('watermark', res.data.catalogType.variable[0].watermark);
              }
              if (item.watermarkSize) {
                localStorage.setItem('watermarkSize', res.data.catalogType.variable[1].watermarkSize);
              }
              if (item.ewmText) {
                localStorage.setItem('ewmText', res.data.catalogType.variable[2].ewmText);
              }
              if (item.ewmSize) {
                localStorage.setItem('ewmSize', res.data.catalogType.variable[3].ewmSize);
              }
              if (item.showState) {
                this.showState = item.showState
              }
              if (item.dialogEwmText) {
                this.dialogEwmText = item.dialogEwmText;
                localStorage.setItem('dialogEwmText', item.dialogEwmText);
              }
              if (item.dialogShare) {
                this.dialogShare = item.dialogShare
              }
              if (item.link) {
                this.link = item.link;
              }
            });
            let ids = (local.getItem('IndexIds')||'').split(',');
            let catalogList = res.data.catalogType.catalogList;
            let posNames = [];
            if (catalogList.length>0)
            {
              for (let i = 0;i < catalogList.length ;i++ )
              {
                posNames.push(catalogList[i].ShortName);
                for (let j = 0;j < catalogList[i].items.length ;j++ )
                {
                  catalogList[i].items[j].collected = findId(ids,catalogList[i].items[j].Id)!==false;
                }
              }
            }
            this.data = res.data.catalogType;
            this.wxcode = this.wxcode||res.data.wxcode;
            localStorage.setItem('wxcode', this.wxcode);
            this.posNames = posNames;
            setTimeout(() => {
              let w = 0;
              console.log(this.$refs.list);
              let list = this.$refs.list;
              for (let i = 0; i < list.length; i++) {
                w += list[i].clientWidth;
              }
              console.log('宽度 = ' + w);
              w = w + 30;
              this.$refs.posin.style.width = w + 'px';
            }, 300);
            this.initok = true;
            resolve();
        })
      });
    }
  },
  beforeDestroy (){
    window.removeEventListener("scroll",scrollFn,false);
    scrollFn = null;
    console.log("解除scroll");
  },
  mounted () {
    share(0,0);
    this.wxcode = local.getItem('IndexWxcode');
    this.getdata();
    let posNow = 0 , posArr1 = [] , posArr2 = [];
    scrollFn = debounce(()=>{
      if (this.scrollByClick===false)
      {
        for (let i = 0;i < this.posNames.length ;i++ )
        {
          let obj = document.querySelector(`#ref${i}`)
          posArr1[i] = obj.getBoundingClientRect().top;
          posArr2[i] = obj.offsetTop;
        }
        posNow = 0
        for (let i = 0;i < posArr1.length ;i++ )
        {
          if (posArr1[i]<0)
          {
            posNow = i;
          }
        }
        // this.posNow = posNow;
        this.posArr = posArr2;
      }else{
        setTimeout(() => {
          this.scrollByClick = false;
        }, 500)
      }
    },500)
    this.$nextTick(()=>{
      initPromise.then((res) => {
        scrollFn()
      })
      window.addEventListener("scroll",scrollFn,false)
    })
  }
}
</script>


<style lang="less" scoped>


  .index{
    overflow-x: hidden;
    width: 100%;
  }
  .logo img{
    width: 100%;
  }
  .pos{
    width: 100%;
    position: fixed;
    bottom: 0px;
    background: #F2F2F2;
    overflow-x: auto;
    .posin{
      div{
        display: inline-block;
        text-align: center;
        padding: 0 15px;
        height: 49px;
        line-height: 49px;
      }
    }
    .arrow{
      position: fixed;
      right: 0;
      bottom: 0;
      width: 30px;
      height: 49px;
      line-height: 49px;
      background: #F2F2F2;
      img{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/Index.vue